import { Link, Skeleton, Stack, Tooltip } from '@mui/material';
import { Link as ReactRouterLink } from 'react-router-dom';

import { Text } from 'common';

import { usePatientQuery } from '../../scenes/Entity/Patient/usePatientQuery';
import { formatUsPlainDateShort } from '../../utils/time';

interface PatientLinkProps {
  ehrInformationId: string;
}

export function PatientLink(props: PatientLinkProps) {
  const { ehrInformationId } = props;
  const { isSuccess, isPending, data } = usePatientQuery({ ehrInformationId });

  if (isPending) {
    return <Skeleton width={64} />;
  }
  return (
    <Tooltip
      arrow
      title={
        isSuccess ? (
          <Stack
            gap={0.5}
            onClick={(event) => {
              event.stopPropagation();
              event.preventDefault();
            }}
          >
            <Text variant="body2" color="inherit">
              <b>First Name: </b>
              {data.patient.firstName}
            </Text>
            <Text variant="body2" color="inherit">
              <b>Last Name: </b>
              {data.patient.lastName}
            </Text>
            <Text variant="body2" color="inherit">
              <b>Date of Birth: </b>
              {formatUsPlainDateShort(data.patient.dateOfBirth, { timeZone: 'utc' })}
            </Text>
            <Text variant="body2" color="inherit">
              <b>MRN: </b> {data.ehrInformation.value}
            </Text>
          </Stack>
        ) : (
          'Loading...'
        )
      }
      placement="left"
    >
      <Link
        onClick={(event) => event.stopPropagation()}
        to={`/entity/patients/${ehrInformationId}`}
        component={ReactRouterLink}
      >
        {isSuccess ? `${data.patient.firstName} ${data.patient.lastName}` : ehrInformationId}
      </Link>
    </Tooltip>
  );
}
